import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const userAccepted = localStorage.getItem('cookie_consent_accepted');
    if (!userAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent_accepted', 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent-container">
      {/* Container para agrupar o título e o texto */}
      <div className="cookie-consent-text-content">
        <h2 className="cookie-consent-title">Sua privacidade e segurança é muito importante para nós</h2>
        <p className="cookie-consent-text">
          Utilizamos cookies e tecnologias similares para reconhecer visitantes,
          recordar preferências e analisar o tráfego do site.
        </p>

        <p className='cookie-consent-text'>
          Ao prosseguir, você declara concordar com nossa {' '}
          <a href="/politica-de-privacidade" className="cookie-consent-link">
            política de privacidade
          </a>
          .
        </p>



      </div>
      {/* O botão fica fora do container de texto para ser alinhado separadamente */}
      <button onClick={handleAccept} className="cookie-consent-button">
        Concordar e Fechar
      </button>
    </div>
  );
};

export default CookieConsent;